<template>
  <div class="ag-draft-update p-4" v-if="draftUpdate && draftUpdate !== 'null'">
    <ul class="ag-draft-update-list">
      <li>
        <span class="lighttext">{{$t("blockAction")}}</span>
        <span class="value">{{draftUpdate.blockType}}</span>
      </li>
      <li>
        <span class="lighttext">{{$t("Actor")}}</span>
        <span class="value">{{draftUpdate.actorName}}</span>
      </li>
      <li>
        <span class="lighttext">{{$t("Target")}}</span>
        <span class="value">{{draftUpdate.targetName}}</span>
        <span class="raw" v-for="(item, key) in ancestorList" :key="key">
          <!-- {{ancestorList}} -->
        </span>
      </li>
      <li>
        <span class="lighttext">{{$t("eventId")}}</span>
        <span class="value">{{draftUpdate.eventId}}</span>
      </li>
    </ul>
    <ul class="ag-draft-update-list wrap">
      <li class="form-group">
        <select name="" id="" class="form-control" v-model="draftUpdate.riskLevel">
          <option value="">{{$t("selectRiskLevel")}}</option>
          <option v-for="(item, key) in riskLevels" :key="key" :value="item.value">{{item.key}}</option>
        </select>
      </li>
      <li class="form-group">
        <select name="" id="" class="form-control" v-model="draftUpdate.permissionLevel">
          <option v-for="(item, key) in permissionLevels" :key="key" :value="item.value">{{item.key}}</option>
        </select>
      </li>
      <li class="form-group">
        <label for="checkbox1">
          <input type="checkbox" id="checkbox1" name="checkbox1" v-model="draftUpdate.allowSigned">
          {{$t("allowSigned")}}
        </label>
      </li>
      <li class="form-group">
        <label for="checkbox2">
          <input type="checkbox" id="checkbox2" name="checkbox2" v-model="draftUpdate.allowTpl">
          {{$t("allowTPL")}}
        </label>
      </li>
      <li class="form-group">
        <label for="checkbox3">
          <input type="checkbox" id="checkbox3" name="checkbox3" v-model="draftUpdate.memoryGuard">
          {{$t("memoryGuard")}}
        </label>
      </li>
    </ul>
    <ul class="ag-draft-update-list dropList">
      <li class="form-group">
        <label for="message">{{$t("notes")}}</label>
      </li>
      <li class="form-group">
        <textarea name="message" id="message" cols="30" rows="3" v-model="draftUpdate.notes" placeholder="Enter a description"></textarea>
      </li>
    </ul>
  </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import ProposedUniqueBlocks from "../../helpers/pages/ProposedUniqueBlocks";
import { ref } from "vue";
import policyChangeChecklistVue from "../../helpers/pages/PolicyChangeChecklist";

const store = useStore();
export default {
  name: "ag-draft-update",
  data: () => ({
    draftUpdate: {
      riskLevel: 0,
      permissionLevel: 0,
      allowSigned: 0,
      allowTpl: 0,
      memoryGuard: 0,
      notes: null,
    },
  }),
  setup() {

    if (!store.state.general.permissionLevels.length) store.dispatch(GeneralActionTypes.GET_PERMISSION_LEVELS, null);
    if (!store.state.general.reviewStatuses.length) store.dispatch(GeneralActionTypes.GET_REVIEW_STATUSES, null);
    if (!store.state.general.riskLevels.length) store.dispatch(GeneralActionTypes.GET_RISK_LEVELS, null);

    let module = ref(policyChangeChecklistVue);
    
    return {
      module
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
    'draftUpdate.riskLevel'(value) {
      this.module.models.draftUpdate.riskLevel = value;
    },
    'draftUpdate.permissionLevel'(value) {
      this.module.models.draftUpdate.permissionLevel = value;
    },
    'draftUpdate.allowSigned'(value) {
      this.module.models.draftUpdate.allowSigned = value;
    },
    'draftUpdate.allowTpl'(value) {
      this.module.models.draftUpdate.allowTpl = value;
    },
    'draftUpdate.memoryGuard'(value) {
      this.module.models.draftUpdate.memoryGuard = value;
    },
    'draftUpdate.notes'(value) {
      this.module.models.draftUpdate.notes = value;
    },
  },
  methods: {
    getList() {
      if (store.state.general.selectedExpandedRow) {
        this.draftUpdate = store.state.general.selectedExpandedRow;
        if (this.draftUpdate.ancestorList) {
          this.ancestorList = this.draftUpdate.ancestorList.map((f) => {
            return f.Path;
          });
        } else {
          console.log(this.draftUpdate)
        }

        this.permissionLevels = store.state.general.permissionLevels;
        this.reviewStatuses = store.state.general.reviewStatuses;
        this.riskLevels = store.state.general.riskLevels;

        // console.log("permissionLevels =>",this.permissionLevels)
        // console.log("reviewStatuses =>",this.reviewStatuses)
        // console.log("riskLevels =>",this.riskLevels)
      }
    },
  }
};
</script>

<style lang="scss">
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
}

.ag-draftUpdate {
  height: 60vh;
  overflow: auto;
}

.ag-draft-update-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 15px 0;
  flex-wrap: wrap;
}

.ag-draft-update-list.wrap {
  padding-top: 70px;
  justify-content: center;
  align-items: center;
}

.ag-draft-update-list li {
  flex-direction: column;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0 15px;
  flex-grow: 1;
}

.ag-draft-update-list li .lighttext {
  color: #8E8E8E;
  font-size: 14px;
}

.ag-draft-update-list li .value {
  color: #8E8E8E;
  font-size: 30px;
}

.ag-draft-update-list li .raw {
  color: #8E8E8E;
  font-size: 12px;
}

.ag-draft-update-list.dropList {
  flex-direction: column;
  margin-top: 70px;
}

.ag-draft-update-list.dropList li {
  width: 100%;
}

.ag-modal .modal-body {
  background: #f8f8f8;
}

.ag-modal .modal-body textarea {
  border-color: #ddd;
  padding: 15px;
}

.ag-modal .modal-body label {
  color: #8E8E8E;
  font-size: 14px;
  margin: 0;
}
</style>
